export default "__VITE_ASSET__33be49ad__"